<template>
  <div class="modal fade" id="UpEmplacementModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-hidden="true" ref="UpEmplacementModalRef">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5">Emplacement</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <Form ref="usagerForm" @submit="soumettre" :validation-schema="usagerSchema">
            <div class="row">
              <!--<div class="col-md-12 col-12 col-sm-12" v-if="mPar">
                <div class="form-group">
                  <label for="parent" class="form-label fw-medium text-black">
                    Emplacement Parent
                  </label>
                  <Field name="parent" v-model="parent" class="form-control shadow-none fs-md-15 text-black"
                    v-slot="{ field }">
                    <Multiselect v-model="field.value" v-bind="field" :filter-results="false" :min-chars="2"
                      :resolve-on-load="false" :delay="0" :searchable="true" :options-limit="300" :options="parOptions" noOptionsText="Tapez au moins deux caractères" placeholder="Rechercher un contrat" />
                  </Field>
                  <ErrorMessage name="contrat" class="text-danger" />
                </div>
              </div>-->
              <div class="col-md-12 col-12 col-sm-12">
                <div class="form-group">
                  <label for="parent" class="form-label fw-medium text-black">
                    Emplacement Parent
                  </label>
                  <Field name="parent" v-model="parent" class="form-control shadow-none fs-md-15 text-black"
                    v-slot="{ field }">
                    <Multiselect v-model="field.value" v-bind="field" :filter-results="false" :min-chars="2"
                      :resolve-on-load="false" :delay="0" :searchable="true" :options-limit="300" :options="async (query) => {
                        if (query.length >= 3) {
                          const results = await reupererContrat(query);
                          if (results && results.length > 0) {
                            return results;
                          } else {
                            return [
                              { value: '', label: 'Aucun enregistrement trouvé' },
                            ];
                          }
                        } else {
                          return [];
                        }
                      }
                        " noOptionsText="Tapez au moins deux caractères" placeholder="Rechercher un contrat" />
                  </Field>
                  <ErrorMessage name="parent" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label class="d-block text-black fw-semibold">
                    Ancien code <span class="text-danger"></span>
                  </label>
                  <Field name="emplacement" v-model="emplacement" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Renseigner le nom" />
                  <ErrorMessage name="emplacement" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label class="d-block text-black fw-semibold">
                    Nouveau code <span class="text-danger"></span>
                  </label>
                  <Field name="ncode" type="text" v-model="ncode" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Nouveau code" />
                  <ErrorMessage name="ncode" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label class="d-block text-black fw-semibold">
                    Taxe mensuelle <span class="text-danger">*</span>
                  </label>
                  <Field name="taux" v-model="taux" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Taux" />
                  <ErrorMessage name="taux" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label class="form-label fw-medium text-black">
                    Secteur
                  </label>
                  <Field name="secteur" v-slot="{ field }" v-model="secteur">
                    <Multiselect :options="secteurs" :searchable="true" v-model="field.value" v-bind="field"
                      placeholder="Sélectionner un secteur" />
                  </Field>
                  <ErrorMessage name="secteur" class="text-danger" />
                </div>
              </div>
              <!--<div class="col-md-6 col-xl-6 col-xm-12" v-if="mLo">
                <label for="contrat" class="form-label fw-medium text-black">
                  <span> Locataire {{ "==> " + loc }}</span>
                  <span>
                    <a href="#" data-bs-toggle="modal" data-bs-target="#AddUsagerModal" @click.prevent="ajouterUsager"
                      type="button"><span class="badge text-bg-success" style="margin-left: 0.3em">A</span></a>
                    <a href="#" data-bs-toggle="modal" data-bs-target="#AddUsagerModal" @click.prevent="modifUsager"
                      type="button"><span class="badge text-bg-secondary ml-5" style="margin-left: 0.3em">M</span></a>
                  </span>
                </label>
                <Field name="locataire" class="form-control shadow-none fs-md-15 text-black"
                  v-slot="{ field }">
                  <Multiselect 
                    :model-value="field.value" 
                    @update:model-value="(value) => { 
                      field.onChange(value); 
                      updateLocataire(value); 
                      loc.value = value; // Synchroniser loc avec la valeur sélectionnée
                    }" 
                    v-bind="field" 
                    :filter-results="false" 
                    :min-chars="2"
                    :resolve-on-load="false" 
                    :delay="0" 
                    :searchable="true" 
                    :options-limit="300" 
                    :options="loOptions" 
                    noOptionsText="Tapez au moins deux caractères" 
                    placeholder="Rechercher un locataire" />
                </Field>
                <Field name="locataire" v-slot="{ field }" v-model="loc"
                  class="form-control shadow-none fs-md-15 text-black">
                  <Multiselect v-model="field.value" v-bind="field" :options="locOptions" :searchable="true"
                    noResultText="Aucun enregistrement trouvé"
                    placeholder="Rechercher un percepteur" />
                </Field>
                <ErrorMessage name="locataire" class="text-danger" />
              </div>
              <div class="col-md-6 col-xl-6 col-xm-12" v-if="mEx">
                <label for="contrat" class="form-label fw-medium text-black">
                  <span> Exploitant {{ "==> " + exp }}</span>
                  <span>
                    <a href="#" data-bs-toggle="modal" data-bs-target="#AddUsagerModal" @click="ajouterUsager1"
                      type="button"><span class="badge text-bg-success" style="margin-left: 0.3em">A</span></a>
                    <a href="#" data-bs-toggle="modal" data-bs-target="#AddUsagerModal" @click="modifUsager1"
                      type="button"><span class="badge text-bg-secondary ml-5" style="margin-left: 0.3em">M</span></a>
                  </span>
                </label>
                <Field name="exploitant" class="form-control shadow-none fs-md-15 text-black" v-slot="{ field }">
                  <Multiselect 
                    :model-value="field.value" 
                    @update:model-value="(value) => { 
                      field.onChange(value); 
                      updateExploitant(value); 
                      exp.value = value; // Synchroniser exp avec la valeur sélectionnée
                    }"
                    v-bind="field"
                    :options="exOptions"
                  />
                </Field>
                <ErrorMessage name="exploitant" class="text-danger" />
              </div>-->
              <div class="col-md-6 col-xl-6 col-xm-12">
                <label for="contrat" class="form-label fw-medium text-black">
                  <span> Locataire <span class="text-danger">*</span></span>
                  <span>
                    <a href="#" data-bs-toggle="modal" data-bs-target="#AddUsagerModal" @click="ajouterUsager"
                      type="button"><span class="badge text-bg-success" style="margin-left: 0.3em">A</span></a>
                    <a href="#" data-bs-toggle="modal" data-bs-target="#AddUsagerModal" @click="modifUsager"
                      type="button"><span class="badge text-bg-secondary ml-5" style="margin-left: 0.3em">M</span></a>
                  </span>
                </label>
                <Field name="locataire" v-model="locataire" class="form-control shadow-none fs-md-15 text-black"
                  v-slot="{ field }">
                  <Multiselect 
                    :model-value="field.value" 
                    v-bind="field" 
                    :filter-results="true" 
                    :min-chars="3"
                    :resolve-on-load="false" 
                    :delay="0"  
                    :searchable="true" 
                    :options-limit="300" 
                    :options="async (query) => {
                      if (query && query.length >= 3) {
                        const results = await reupererUsagers(query);
                        if (results && results.length > 0) {
                          return results;
                        } else if (results.length >= 3) {
                          return [
                            {
                              value: '',
                              label: 'Aucun enregistrement trouvé',
                            },
                          ];
                        } else {
                          return [];
                        }
                      }
                    }"  
                    noOptionsText="Tapez au moins deux caractères" 
                    placeholder="Rechercher un locataire" />
                </Field>
                <ErrorMessage name="locataire" class="text-danger" />
              </div>
              <div class="col-md-6 col-xl-6 col-xm-12">
                <label for="contrat" class="form-label fw-medium text-black">
                  <span> Exploitant <span class="text-danger">*</span></span>
                  <span>
                    <a href="#" data-bs-toggle="modal" data-bs-target="#AddUsagerModal" @click="ajouterUsager1"
                      type="button"><span class="badge text-bg-success" style="margin-left: 0.3em">A</span></a>
                    <a href="#" data-bs-toggle="modal" data-bs-target="#AddUsagerModal" @click="modifUsager1"
                      type="button"><span class="badge text-bg-secondary ml-5" style="margin-left: 0.3em">M</span></a>
                  </span>
                </label>
                <Field name="exploitant" v-model="exploitant" class="form-control shadow-none fs-md-15 text-black"
                  v-slot="{ field }">
                  <Multiselect 
                    :model-value="field.value" 
                    v-bind="field" 
                    :filter-results="false" 
                    :min-chars="3"
                    :resolve-on-load="false" 
                    :delay="0" 
                    :searchable="true" 
                    :options-limit="300" 
                    :options="async (query) => {
                      if (query && query.length >= 3) {
                        const results = await reupererUsagers(query);
                        if (results && results.length > 0) {
                          return results;
                        } else if (results.length >= 3) {
                          return [
                            {
                              value: '',
                              label: 'Aucun enregistrement trouvé',
                            },
                          ];
                        } else {
                          return [];
                        }
                      }
                    }" 
                    noOptionsText="Tapez au moins deux caractères" 
                    placeholder="Rechercher un exploitant" />
                </Field>
                <ErrorMessage name="exploitant" class="text-danger" />
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label class="form-label fw-medium text-black">
                    Type emplacement <span class="text-danger">*</span>
                  </label>
                  <Field name="typeEmplacement" v-slot="{ field }">
                    <Multiselect :options="types" :searchable="true" :model-value="field.value" @update:model-value="field.onChange" v-bind="field"
                      placeholder="Sélectionner un type emplacement" />
                  </Field>
                  <ErrorMessage name="typeEmplacement" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label class="form-label fw-medium text-black">
                    Activite<span class="text-danger">*</span>
                  </label>
                  <Field name="activite" v-slot="{ field }">
                    <Multiselect :options="activites" :searchable="true" :model-value="field.value" @update:model-value="field.onChange" v-bind="field"
                      placeholder="Sélectionner une activité" />
                  </Field>
                  <ErrorMessage name="activite" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label class="d-block text-black fw-semibold">
                    Plus detail activité <span class="text-danger">*</span>
                  </label>
                  <Field name="nouveau_activite" v-model="nouveau_activite"
                    class="form-control shadow-none fs-md-15 text-black" placeholder="Tomate" />
                  <ErrorMessage name="nouveau_activite" class="text-danger" />
                </div>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col-md-3 text-md-end text-xl-end text-sm-center col-sm-12">
                <button type="submit" class="btn btn-primary w-100">
                  Enregistrer
                </button>
              </div>
            </div>
          </Form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
            Fermer
          </button>
        </div>
      </div>
    </div>
  </div>
  <AddUsagerModal :item="selectedItem" @close="recharger" @open="show_Modal" />
</template>
<script lang="ts">
import { defineComponent, ref, watch, onMounted } from "vue";
import { Form, Field, ErrorMessage, useResetForm } from "vee-validate";
import Multiselect from "@vueform/multiselect";
import { Option } from "@/models/Option";
import { hideModal, showModal, success, error } from "@/utils/utils";
import * as Yup from "yup";
import axios, { AxiosError } from "axios";
import ApiService from "@/services/ApiService";
import AddUsagerModal from "./Usager.vue";

export default defineComponent({
  name: "UpEmplacementModal",
  components: {
    Form,
    Field,
    ErrorMessage,
    AddUsagerModal,
    Multiselect,
  },
  props: {
    item: {
      type: String,
      required: true,
    },
  },
  setup: (props, { emit }) => {
    const usagerSchema = Yup.object().shape({
      locataire: Yup.string().required("Le locataire est obligatoire"),
      exploitant: Yup.string().required("Le exploitant est obligatoire"),
      emplacement: Yup.string().required("Le code est obligatoire"),
      ncode: Yup.string().required("Le nouveau code est obligatoire"),
      secteur: Yup.string().required("Le secteur est obligatoire"),
      taux: Yup.string().required("Le taux est obligatoire"),
      typeEmplacement: Yup.string().required("Le type d'emplacement est obligatoire"),
      activite: Yup.string().required("L'activité est obligatoire"),
      nouveau_activite: Yup.string().notRequired(),
      parent: Yup.string().notRequired(),
    });

    const usagerForm = ref<any | null>(null);
    const emplacement = ref();
    const nouveau_activite = ref();
    const ncode = ref();
    const secteur = ref();
    const secteurs = ref();
    const types = ref();
    
    const taux = ref();
    const typeEmplacement = ref();
    const exploitant = ref();
    const activite = ref();
    const selectedItem = ref();
    const locataire = ref();
    const matricule = ref();
    const loc = ref();
    const exp = ref();
    const mLo = ref(true);
    const loOptions = ref<any[]>([]);
    const mEx = ref(true);
    const exOptions = ref<any[]>([]);
    const mPar = ref(true);
    const parOptions = ref<any[]>([]);
    const par = ref();
    const UpEmplacementModalRef = ref<null | HTMLElement>(null);
    const sexes = ref([
      { value: "Masculin", label: "Masculin" },
      { value: "Féminin", label: "Féminin" },
      { value: "Autre", label: "Autre" },
    ]);

    const ajouterUsager = () => {
      selectedItem.value = null;
    };

    const modifUsager = () => {
      selectedItem.value = locataire.value;
    };

    const ajouterUsager1 = () => {
      selectedItem.value = null;
    };

    const recharger = () => {
      //console.log("Oui c'est bon");
    };

    const modifUsager1 = () => {
      selectedItem.value = exploitant.value;
    };

    const updateLocataire = (value) => {
      loc.value = value;
    };

    const updateExploitant = (value) => {
      exp.value = value;
    };

    const reupererUsagers = async (recherche) => {
      try {
        const response = await ApiService.post("getUsagerByKey", { recherche });
        if (response.data) {
          return response.data.data.map((el) => {
            return {
              value: el.matricule,
              label: `${el.matricule} || ${el.nom}  ${el.prenom}  ${el.tel ? " - " + el.tel : ""
                }`,
            };
          });
        }
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          error(err.response.data.message || err.message);
        } else {
          if (err instanceof Error) {
            error(err.message);
          } else {
            error(String(err));
          }
        }
      }
    };

    const resetForm = () => {
      emplacement.value = null;
      locataire.value = null;
      exploitant.value = null;
      ncode.value = null;
      secteur.value = null;
      typeEmplacement.value = null;
      activite.value = null;
      nouveau_activite.value = null;
      taux.value = null;
      loOptions.value = [];
      exOptions.value = [];
      parOptions.value = [];
    };
    const locataires = ref<Array<any>>([]);
    const exploitants = ref<Array<any>>([]);

    const fetchLocataireOptions = async (query: any = null) => {
      if (query && query.length >= 3) {
        const results = await reupererUsagers(query);
        if (results && results.length > 0) {
          return results;
        } else {
          return [
            {
              value: "",
              label: "Aucun enregistrement trouvé"
            },
          ];
        }
      }
      if (query == null) {
        return locataires.value;
      }
      return [];
    };


    const fetchExploitantOptions = async (query: any = null) => {
      if (query && query.length >= 3) {
        const results = await reupererUsagers(query);
        if (results && results.length > 0) {
          return results;
        } else {
          return [
            {
              value: "",
              label: "Aucun enregistrement trouvé",
            },
          ];
        }
      }
      if (query == null) {
        return exploitants.value;
      }
      return [];
    };

    const reupererContrat = async (recherche) => {
      try {
        const response = await ApiService.post("listeContrat", { recherche });
        if (response.data) {
          return (response.data.data.map((el) => {
            return {
              value: el.id,
              label:
                el.ref + " - Lo : " + el.locataire + `${el.exploitant ? " - Ex : "+el.exploitant : ""}`,
            };
          }));
        }
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          error(err.response.data.message || err.message);
        } else {
          if (err instanceof Error) {
            error(err.message);
          } else {
            error(String(err));
          }
        }
      }
    };

    const getUsager = async (matricule: string) => {
      try {
        const response = await axios.get(`emplacement/${matricule}`);
        if (response.data.data) {

          const lusager = response.data.data;
          emplacement.value = lusager.codeemp;
          ncode.value = lusager.ncode_emp;
          secteur.value = lusager?.secteur?.code_secteur;
          typeEmplacement.value = lusager?.type_emplacement?.id;
          taux.value = lusager.montant_location;
          loOptions.value = [];
          exOptions.value = [];
          parOptions.value = [];

          if (lusager?.locataire) {
            locataires.value = [
              {
                value: lusager.locataire?.matricule,
                label: `${lusager.locataire?.matricule} || ${lusager.locataire?.nom
                  }  ${lusager.locataire?.prenom}  ${lusager.locataire?.tel ? " - " + lusager.locataire?.tel : ""
                  }`,
                  selected: true,
              },
            ];
            loOptions.value = locataires.value;
            loc.value = lusager.locataire?.matricule;
          }

          if (lusager?.exploitant) {
            exploitants.value = [
              {
                value: lusager.exploitant?.matricule,
                label: `${lusager.exploitant?.matricule} || ${lusager.exploitant?.nom
                  }  ${lusager.exploitant?.prenom}  ${lusager.exploitant?.tel ? " - " + lusager.exploitant?.tel : ""
                  }`,
                  selected: true,
              },
            ];
            exOptions.value = exploitants.value;
            exp.value = lusager.exploitant?.matricule;
          }
          //fetchExploitantOptions(null);
          //fetchLocataireOptions(null);
          //exploitant.value = lusager?.exploitant?.matricule;
          //locataire.value = lusager.locataire?.matricule;
        } else {
          error("Erreur lors de la récupération de l'usager");
        }
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          error(err.response.data.message || err.message);
        } else {
          if (err instanceof Error) {
            error(err.message);
          } else {
            error(String(err));
          }
        }
      }
    };

    const activites = ref([]);
    const reupererActivite = async () => {
      try {
        const response = await ApiService.get("listeActivite");
        if (response.data) {
          return (activites.value = response.data.data.map((el) => {
            return {
              value: el.activite_nom,
              label: el.activite_nom,
            };
          }));
        }
      } catch (err) {
        error(err);
      }
    };

    const reupererTypeEmplacement = async () => {
      try {
        const response = await ApiService.get("all/type/emplacement");
        if (response.data) {
          return (types.value = response.data.data.map((el) => {
            return {
              value: el.id,
              label: el.libelleTypeEmp,
            };
          }));
        }
      } catch (err) {
        //console.log("Err ===> ", err);
        error(err);
      }
    };

    const reupererSecteur = async () => {
      try {
        const response = await ApiService.get("all/secteur");
        if (response.data) {
          return (secteurs.value = response.data.data.map((el) => {
            return {
              value: el.code_secteur,
              label: el.libelle_secteur,
            };
          }));
        }
      } catch (err) {
        //"Err ===> ", err);
        error(err);
      }
    };

    watch(
      () => props.item,
      async (newValue) => {
        reupererTypeEmplacement();
        reupererSecteur();
        reupererActivite();
        if (newValue !== null) {
          matricule.value = newValue;
          await getUsager(newValue);
        } else {
          resetForm();
        }
      }
    );

    const soumettre = async (values, { resetForm }) => {
      values["emplacement"] = matricule.value;
      try {
        const response = await axios.post("mettre/a/jour", values);
        const retour = response.data.data;
        if (matricule.value) {
          success("L'usager a été modifié avec succès");
        } else {
          success("L'usager a été enregistré avec succès");
        }
        resetForm();
        hideModal(UpEmplacementModalRef.value);
        emit("close");
      } catch (err) {
        //
        if (err instanceof AxiosError) {
          error(err.response?.data?.message);
        } else {
          error("Une erreur est survenue");
        }
      }
    };
    const show_Modal = (el) => {
      showModal(el);
      selectedItem.value = 0;
    };

    return {
      show_Modal,
      recharger,
      loc,
      exp,
      mLo,
      mEx,
      mPar,
      props,
      loOptions,
      exOptions,
      parOptions,
      par,
      fetchExploitantOptions,
      fetchLocataireOptions,
      modifUsager,
      ajouterUsager,
      modifUsager1,
      ajouterUsager1,
      updateLocataire,
      updateExploitant,
      reupererUsagers,
      emplacement,
      secteur,
      secteurs,
      ncode,
      sexes,
      reupererTypeEmplacement,
      reupererSecteur,
      taux,
      locataires,
      exploitants,
      typeEmplacement,
      reupererActivite,
      UpEmplacementModalRef,
      soumettre,
      exploitant,
      locataire,
      types,
      matricule,
      usagerSchema,
      usagerForm,
      activites,
      activite,
      reupererContrat,
      selectedItem,
      nouveau_activite
    };
  },
});
</script>

<style src="@vueform/multiselect/themes/default.css"></style>